/**
 * F13.6 — Célula percentual reutilizável.
 *
 * Formata inteiros sem casa decimal (`30%`) e fracionários com 1 casa
 * (`28,5%`). Quando `value` é null/undefined/NaN, renderiza traço muted.
 *
 * Padrão monoespaçado para alinhamento em colunas.
 */

import { toNumber } from "../../lib/format-fr.js";

interface Props {
  value: number | string | null | undefined;
  variant?: "lime" | "muted" | "default";
}

const COLOR_BY_VARIANT: Record<NonNullable<Props["variant"]>, string> = {
  lime: "text-lime",
  muted: "text-text-muted",
  default: "text-text-primary",
};

const pctIntl1 = new Intl.NumberFormat("fr-FR", {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

export function PercentageCell({ value, variant = "lime" }: Props) {
  const n = toNumber(value);
  if (n === null) {
    return <span className="text-text-muted">—</span>;
  }
  const display = n % 1 === 0 ? `${n.toFixed(0)}%` : `${pctIntl1.format(n)}%`;
  return <span className={`font-mono text-sm ${COLOR_BY_VARIANT[variant]}`}>{display}</span>;
}
